var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusZuid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.861,
    height: 13.861,
    viewBox: "0 0 13.861 13.861",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130",
    transform: "translate(-558.631 -525.903)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M329.963,259.767a6.931,6.931,0,1,1-6.931-6.931,6.931,6.931,0,0,1,6.931,6.931",
    transform: "translate(242.529 273.067)",
    fill: "#02a29b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M397.732,326.8h-2.379v-2.435a.574.574,0,0,0-1.148,0V326.8h-2.379a.574.574,0,0,0,0,1.148H394.2v2.322a.574.574,0,1,0,1.148,0v-2.322h2.379a.574.574,0,1,0,0-1.148",
    transform: "translate(170.975 205.505)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusZuid);
export default __webpack_public_path__ + "static/media/PlusZUID.27e38cedb82d70cd7d9a6ed45e37d1bb.svg";
export { ForwardRef as ReactComponent };